import { apiGet } from "@/lib/http/client";
import type { ExportJobListResponse } from "@/types/api";

export async function fetchExportJobs(params: Record<string, unknown>) {
  return apiGet<ExportJobListResponse>("/export-jobs", params);
}
